module.exports = __webpack_public_path__ + "static/media/seed_logo.0bf77490.png";